import { Row } from 'react-table'
import { TemplateDetailOption } from '../../generated/graphql'
import { DetailLabelConfig } from '../../types'

export enum TemplateType {
  Plan = 'Plan',
  Placeholder = 'Placeholder'
}

// Campus is the only field we conditionally show currently,
// Return undefined if it's not in the config list
const formatCampus = (detailConfig: TemplateDetailOption[] | undefined, campusText: string) => {
  if (!detailConfig) {
    return undefined
  }

  const config = detailConfig.find((k: TemplateDetailOption) => k.key === 'Campus')
  if (!config) {
    return undefined
  }

  if (!config.label) {
    return campusText
  }
  return config.label
}

const formatLabel = (key: string, detailConfig: TemplateDetailOption[] | undefined) => {
  if (!detailConfig) {
    return key
  }

  const config = detailConfig.find((k: TemplateDetailOption) => k.key === key)
  return config?.label || key
}

const formatTemplateLabels = (
  detailConfig: TemplateDetailOption[] | undefined,
  campusText: string
): DetailLabelConfig => ({
  campus: formatCampus(detailConfig, campusText),
  college: formatLabel('College', detailConfig),
  concentration: formatLabel('Concentration', detailConfig),
  degree: formatLabel('Degree', detailConfig),
  major: formatLabel('Major', detailConfig),
  minor: formatLabel('Minor', detailConfig)
})

export const calculateInputWidth = (
  isMedium: boolean,
  isMultiline: boolean,
  isSmall: boolean,
  title: string
) => {
  let width = 340
  if (isMultiline) {
    if (title.length >= 30) {
      width = (title.length + 1) * 8
    }
  } else if (title.length > 0 && title.length <= 30) {
    width = (title.length + 1) * 15 + 50
  }

  if (isSmall && width > 330) {
    width = 330
  } else if (isMedium && width > 400) {
    width = 400
  } else if (!isSmall && width > 500) {
    width = isMultiline ? 450 : 500
  }

  return width
}

export const typeFilter = (rows: Array<Row>, id: string, filterValue: string[]) => {
  let filteredRows: Array<Row> = []
  const findType = (c: any) => (c.isCoursePlaceholder ? 'Course' : 'Non-Course')

  // Empty Filter Value OR Select All - don't filter any rows
  if (!filterValue || !filterValue.length || filterValue.includes('Select All')) {
    return rows
  }

  filteredRows = rows.filter((row: Row) =>
    // Use findType to find the value of the course status
    filterValue.includes(findType(row.original))
  )
  return filteredRows
}

export default formatTemplateLabels
